export default {
  header: 'Oeps, er is iets onverwachts gebeurd',
  text: 'Start de pagina opnieuw op of klik op de knop "Terug naar menu" hieronder.',
  button: 'Terug naar start',
};
